export default {
    url: '/classic',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 895,
        title: 'Classic',
    },
    controller: [
        '$scope',
        'jsonrpc',
        function($scope, jsonrpc) {
            $scope.get_data_method = jsonrpc.newServiceMethod('retention.classic');
        },
    ],
}
